export const ImageNotFound = require('@/assets/icons/fallback.svg');
export const ImageNotFoundOprema = require('@/assets/icons/oprema-fallback.svg');
export const GoogleCloudGeocodingApiKey = 'AIzaSyAl4rXfKqh_tX22wQqG3gufbbCsnsnfxoo';
export const GoogleCloudGeolocationApiKey = 'AIzaSyBONcM1FkI6CzaDO3iYuSfqhgIMuoAUTnE';
